/**
 * @file ppde页面的header
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useCallback, useEffect, useState} from 'react';
import {Tabs} from 'antd';
import throttle from 'lodash/throttle';
import ReactStickyPolyfill from '../../../../components/react-sticky-polyfill/ReactStickyPolyfill';
import {getScrollTop} from '../../../../utils/get-scroll';

const PpdeHeader: React.FC = (props) => {
    const [tabActiveKey, setTabActiveKey] = useState<string>();

    useEffect(() => {
        const domList: HTMLAnchorElement[] = Array.from(document.querySelectorAll('.anchor'));
        const theScrollTop = getScrollTop();
        const domTopList: number[] = domList.map(d => (d.getBoundingClientRect().top + theScrollTop));

        const onScroll = throttle(() => {
            const availHeight = window.screen.availHeight;
            const theScrollTop = getScrollTop();
            const targetIndex = domTopList.findIndex((top) => {
                return (top - theScrollTop) + availHeight / 3 > 0;
            });
            const activeKey = domList[targetIndex]?.id;
            if (activeKey) {
                setTabActiveKey(activeKey);
            }
        }, 50);

        window.addEventListener('scroll', onScroll);

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    const onTabChange = useCallback((activeKey: string) => {
        window.location.href = `#${activeKey}`;
        setTabActiveKey(activeKey);
    }, []);

    return (
        <ReactStickyPolyfill>
            <Tabs
                className="paddle-ppde-tabs"
                activeKey={tabActiveKey}
                onChange={onTabChange}
            >
                <Tabs.TabPane
                    key="PPDE首页"
                    tab="PPDE首页"
                />
                <Tabs.TabPane
                    key="PPDE成员"
                    tab="PPDE成员"
                />
                <Tabs.TabPane
                    key="PPDE精选项目"
                    tab="PPDE精选项目"
                />
                <Tabs.TabPane
                    key="PPDE专属权益"
                    tab="PPDE专属权益"
                />
                <Tabs.TabPane
                    key="关于我们"
                    tab="关于我们"
                />
            </Tabs>
        </ReactStickyPolyfill>
    );
};

export default PpdeHeader;
